import React from 'react';

/**
 * Original illustration of a box truck. Box length is drawn to scale between 16/20/26 ft so sizes are
 * visually distinguishable. Not a photo and not a specific vehicle in the fleet.
 */
export function TruckIllustration({
  lengthFt,
  className = ''
}: {
  lengthFt: 16 | 20 | 26 | null;
  className?: string;
}) {
  const W = 320;
  const H = 150;
  const ground = 122;
  if (lengthFt === null) {
    return <svg viewBox={`0 0 ${W} ${H}`} className={className} role="img" aria-hidden="true" data-id="element-1053" data-mp="2ras0cikuzvlb">
        <rect width={W} height={H} fill="#F7F6F2" data-id="element-1054" data-mp="2mdich7d4brzl" />
        {[16, 20, 26].map((l, i) => {
        const len = l * 6;
        const x = 20 + i * 4;
        const y = 30 + i * 22;
        return <rect key={l} x={x} y={y} width={len} height={18} rx={3} fill="none" stroke="#111214" strokeOpacity={0.25 + i * 0.25} strokeWidth={2} strokeDasharray={i === 2 ? '0' : '5 4'} data-id="element-1055" data-mp="2w2a053b5bq4p" data-mpi={i} />;
      })}
        <text x={W / 2 + 40} y={H / 2 + 8} textAnchor="middle" fontSize="44" fontWeight="900" fill="#F50087" data-id="element-1056" data-mp="36198eks01jr6">?</text>
      </svg>;
  }
  const boxLen = lengthFt * 8.4; // px per ft
  const boxH = 50 + (lengthFt - 16) * 1.2;
  const cabW = 46;
  const startX = (W - (boxLen + cabW + 4)) / 2;
  const boxX = startX;
  const boxY = ground - 14 - boxH;
  const cabX = boxX + boxLen + 4;
  const wheel = (cx: number) => <g key={cx} data-id="element-1057" data-mp="2aejfpetjgbgd">
      <circle cx={cx} cy={ground - 4} r={12} fill="#111214" data-id="element-1058" data-mp="2af2uimnw6jq6" />
      <circle cx={cx} cy={ground - 4} r={5} fill="#D9DAD6" data-id="element-1059" data-mp="2fde5j0pxb09z" />
    </g>;
  return <svg viewBox={`0 0 ${W} ${H}`} className={className} role="img" aria-hidden="true" data-id="element-1060" data-mp="2jdy3u7m8g9xp">
      <rect width={W} height={H} fill="#F7F6F2" data-id="element-1061" data-mp="2o4wiz3vhj1zd" />
      <line x1={8} x2={W - 8} y1={ground + 8} y2={ground + 8} stroke="#111214" strokeOpacity={0.12} strokeWidth={2} data-id="element-1062" data-mp="2o67mr3oxk9qh" />
      <rect x={boxX} y={boxY} width={boxLen} height={boxH} rx={4} fill="#FFFFFF" stroke="#111214" strokeWidth={2} data-id="element-1063" data-mp="2t37stels5chl" />
      <rect x={boxX} y={boxY + boxH - 14} width={boxLen} height={6} fill="#8BFF24" data-id="element-1064" data-mp="2y19bhyfan9sj" />
      <rect x={boxX - 2} y={ground - 14} width={boxLen + cabW + 8} height={8} rx={2} fill="#111214" data-id="element-1065" data-mp="332f9obrq3p9g" />
      <path d={`M${cabX} ${ground - 14} V${boxY + boxH - 40} H${cabX + 26} L${cabX + cabW} ${boxY + boxH - 20} V${ground - 14} Z`} fill="#111214" data-id="element-1066" data-mp="2dbxbeyw05uhk" />
      <path d={`M${cabX + 6} ${boxY + boxH - 34} H${cabX + 24} L${cabX + 38} ${boxY + boxH - 20} H${cabX + 6} Z`} fill="#D9F7FF" data-id="element-1067" data-mp="2n43285aiq5v6" />
      {wheel(boxX + 26)}
      {lengthFt === 26 && wheel(boxX + 52)}
      {wheel(cabX + cabW - 16)}
      <line x1={boxX} x2={boxX + boxLen} y1={boxY - 10} y2={boxY - 10} stroke="#F50087" strokeWidth={2} data-id="element-1068" data-mp="2w2y79e1tt9ww" />
      <line x1={boxX} x2={boxX} y1={boxY - 15} y2={boxY - 5} stroke="#F50087" strokeWidth={2} data-id="element-1069" data-mp="2r56hoqonlzvv" />
      <line x1={boxX + boxLen} x2={boxX + boxLen} y1={boxY - 15} y2={boxY - 5} stroke="#F50087" strokeWidth={2} data-id="element-1070" data-mp="36270u5ss4miq" />
      <text x={boxX + boxLen / 2} y={boxY - 16} textAnchor="middle" fontSize="13" fontWeight="800" fill="#F50087" data-id="element-1071" data-mp="311j91hwq81ng">
        {lengthFt} ft
      </text>
    </svg>;
}